import { PublicChat } from "./chat/ai-public-chat";
import { PublicEcommerce } from "./ecommerce/public-ecommerce";
import { useTenantConfig } from "~/tenant-settings";

export const OnboardingEntrypoint: React.FC = () => {
  const t = useTenantConfig();
  return t.onboardingType == "chat" ? <PublicChat /> : <PublicEcommerce />;
};
